import React from "react";

import ACIconWrapper, { ACIconProps } from "./ACIconWrapper";

export default function MenuIcon(props: ACIconProps) {
  return <ACIconWrapper component={IconSvg} {...props} />;
}

const IconSvg = () => {
  return (
    <svg height="1em" viewBox="0 0 24 24" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13 6C13 6.82842 12.3284 7.5 11.5 7.5C10.6716 7.5 10 6.82842 10 6C10 5.17158 10.6716 4.5 11.5 4.5C12.3284 4.5 13 5.17158 13 6ZM13 12C13 12.8284 12.3284 13.5 11.5 13.5C10.6716 13.5 10 12.8284 10 12C10 11.1716 10.6716 10.5 11.5 10.5C12.3284 10.5 13 11.1716 13 12ZM11.5 19.5C12.3284 19.5 13 18.8284 13 18C13 17.1716 12.3284 16.5 11.5 16.5C10.6716 16.5 10 17.1716 10 18C10 18.8284 10.6716 19.5 11.5 19.5Z"
        fill="currentColor"
      />
    </svg>
  );
};
